
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getUpdateLiveGame = (params) => {
    return axios.get(`${backendHost}/api/admin/games/live/list/`);
};

export {
    getUpdateLiveGame
}